import { Reveal, Eyebrow } from "./Reveal";

const AUDIENCES = [
    {
        num: "01",
        title: "New businesses",
        desc: "Launch looking legit from day one — brand, visuals and presence that feel established.",
        accent: "#D3A0A7",
    },
    {
        num: "02",
        title: "Established brands",
        desc: "Ready for a refresh? We sharpen how the world sees you, online and everywhere else.",
        accent: "#A9C6DE",
    },
    {
        num: "03",
        title: "Growing teams",
        desc: "Consistent design, content and marketing — handled, so you can run the business.",
        accent: "#D3A0A7",
    },
];

export const WhoWeFor = () => (
    <section
        data-testid="who-we-for-section"
        className="py-20 md:py-28 px-5 sm:px-8 lg:px-12 bg-[#0C0C0C] border border-[#262626] rounded-[2.5rem] mx-3 md:mx-6 my-6"
    >
        <div className="max-w-7xl mx-auto">
            <div className="max-w-2xl mb-14 md:mb-16">
                <Reveal>
                    <Eyebrow>Who we&apos;re for</Eyebrow>
                </Reveal>
                <Reveal delay={0.1}>
                    <h2 className="mt-4 font-serif-ed text-3xl sm:text-4xl lg:text-5xl leading-[1.12] tracking-tight text-[#F1F1EF]">
                        Any business ready to level up its{" "}
                        <span className="italic text-[#D3A0A7]">
                            digital presence.
                        </span>
                    </h2>
                </Reveal>
                <Reveal delay={0.18}>
                    <p className="mt-5 max-w-xl text-base md:text-lg leading-relaxed text-[#A9A6A0]">
                        Big or small, brand new or well established — if your
                        business needs to look sharper online, show up
                        consistently, and turn attention into customers, Savv is
                        built for you.
                    </p>
                </Reveal>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-6">
                {AUDIENCES.map((a, i) => (
                    <Reveal key={a.num} delay={i * 0.1} className="h-full">
                        <div
                            data-testid={`audience-card-${a.num}`}
                            className="h-full rounded-3xl border border-[#262626] p-8 md:p-9 hover:border-[#3A3936] transition-colors duration-300"
                        >
                            <span
                                className="font-serif-ed italic text-lg"
                                style={{ color: a.accent }}
                            >
                                {a.num}
                            </span>
                            <h3 className="mt-10 font-serif-ed text-2xl tracking-tight text-[#F1F1EF]">
                                {a.title}
                            </h3>
                            <p className="mt-2.5 text-sm md:text-base leading-relaxed text-[#A9A6A0]">
                                {a.desc}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
